var _path, _path2, _ellipse;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLPinstagramicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "instagram",
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.823,
    height: 13.823,
    viewBox: "0 0 13.823 13.823",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_17207",
    "data-name": "Caminho 17207",
    d: "M9.7,0H4.118A4.122,4.122,0,0,0,0,4.118V9.7a4.122,4.122,0,0,0,4.118,4.118H9.7A4.122,4.122,0,0,0,13.823,9.7V4.118A4.123,4.123,0,0,0,9.7,0Zm2.727,9.7A2.727,2.727,0,0,1,9.7,12.432H4.118A2.727,2.727,0,0,1,1.391,9.7V4.118A2.727,2.727,0,0,1,4.118,1.391H9.7a2.727,2.727,0,0,1,2.727,2.727V9.7Z",
    transform: "translate(0)",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_17208",
    "data-name": "Caminho 17208",
    d: "M136.575,133a3.575,3.575,0,1,0,3.575,3.575A3.579,3.579,0,0,0,136.575,133Zm0,5.759a2.184,2.184,0,1,1,2.184-2.184A2.184,2.184,0,0,1,136.575,138.759Z",
    transform: "translate(-129.664 -129.664)",
    fill: "currentColor"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_111",
    "data-name": "Elipse 111",
    cx: 0.857,
    cy: 0.857,
    rx: 0.857,
    ry: 0.857,
    transform: "translate(9.637 2.506)",
    ffill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLPinstagramicon);
export default __webpack_public_path__ + "static/media/LPinstagramicon.ebd7d60996d550c52ef094e0e7168ba0.svg";
export { ForwardRef as ReactComponent };